import { DateTime } from "luxon";

export enum RedmineNewsPriority {
    Low = 1,
    Medium = 2,
    High = 3,
    Critical = 4
}

export interface INewsMakerDTO {
    readonly idGlobal: string;
    readonly id: number;
    readonly subject: string;
    readonly description: string;
    readonly startDate: DateTime | null;
    readonly dueDate: DateTime | null;
    readonly estimatedHour: number;
    readonly priority: RedmineNewsPriority;
}

export interface INewsMakerViewDTO {
    readonly idGlobal: string;
    readonly id: number;
    readonly subject: string;
    readonly description: string;
    readonly startDate: DateTime | null;
    readonly dueDate: DateTime | null;
    readonly estimatedHour: number;
    readonly deleted: boolean;
    readonly priority: RedmineNewsPriority;
    readonly dateCreated: DateTime;
    readonly dateModified: DateTime;
    readonly dateDeleted: DateTime;
}
export interface INewsMakerItemCreateDTO {
    readonly id: number;
    readonly subject: string;
    readonly description: string;
    readonly startDate: DateTime | null;
    readonly dueDate: DateTime | null;
    readonly estimatedHour: number;
    readonly priority: RedmineNewsPriority;
}

export interface INewsMakerItemEditDTO extends INewsMakerItemCreateDTO {
    readonly idGlobal: string;
}

//интерфейсы для чата
export interface INewsChatDTO extends INewsMakerDTO {
}

export interface INewsChatViewDTO extends INewsChatDTO {
    readonly isViewed: boolean;
}

//рассылка новостей
export interface INews2User {
    readonly redmineNewsId: string,
    readonly userId: string
    readonly isViewed: boolean
}